import React from "react";
import { Link } from "react-router-dom";

// Shared lightweight header + prose wrapper for legal pages
const LegalLayout = ({ title, updated, children }) => (
  <div className="font-body bg-[#fdfbf7] min-h-screen">
    <div className="pt-32 md:pt-40 pb-10 border-b border-[#ece3d1]">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <div className="flex items-center gap-4 mb-5">
          <span className="w-10 h-px bg-[#b8893a]" />
          <p className="eyebrow text-[#b8893a]">Yasal Bilgilendirme</p>
        </div>
        <h1 className="font-display text-4xl md:text-6xl text-[#2b2620] font-500 leading-tight">
          {title}
        </h1>
        {updated && (
          <p className="text-[12px] text-[#9a8f7d] mt-5 uppercase tracking-[0.16em]">
            Son güncelleme: {updated}
          </p>
        )}
      </div>
    </div>

    <section className="py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-5 md:px-8 legal-prose">{children}</div>
    </section>

    <div className="border-t border-[#ece3d1]">
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-8 flex flex-wrap gap-x-6 gap-y-3 text-[12px] uppercase tracking-[0.12em]">
        <Link to="/gizlilik-politikasi" className="text-[#7a7264] hover:text-[#b8893a] transition-colors" data-testid="legal-link-privacy">Gizlilik Politikası</Link>
        <Link to="/cerez-politikasi" className="text-[#7a7264] hover:text-[#b8893a] transition-colors" data-testid="legal-link-cookies">Çerez Politikası</Link>
        <Link to="/kvkk" className="text-[#7a7264] hover:text-[#b8893a] transition-colors" data-testid="legal-link-kvkk">KVKK Aydınlatma</Link>
        <Link to="/kullanim-kosullari" className="text-[#7a7264] hover:text-[#b8893a] transition-colors" data-testid="legal-link-terms">Kullanım Koşulları</Link>
      </div>
    </div>
  </div>
);

export default LegalLayout;
